import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const headers = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
  },
});

const instantOrdersApi = {
  getQueue: async (filters: any = {}) => {
    const { status, search, kitchenId } = filters;

    let url = `${API_URL}/api/admin/instant-orders/queue`;
    const params = [];
    if (kitchenId) params.push(`kitchenId=${encodeURIComponent(kitchenId)}`);
    if (status) params.push(`status=${encodeURIComponent(status)}`);
    if (search) params.push(`search=${encodeURIComponent(search)}`);
    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    const response = await axios.get(url, headers());
    return response.data;
  },

  getOrders: async (filters: any = {}) => {
    const {
      status,
      search,
      kitchenId,
      date,
      period,
      startDate,
      endDate,
      paymentStatus,
      page = 1,
      limit = 20,
      sortBy = "createdAt",
      sortOrder = "desc",
    } = filters;

    let url = `${API_URL}/api/admin/instant-orders?page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`;
    if (status) url += `&status=${encodeURIComponent(status)}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (kitchenId) url += `&kitchenId=${encodeURIComponent(kitchenId)}`;
    if (date) url += `&date=${encodeURIComponent(date)}`;
    if (period) url += `&period=${encodeURIComponent(period)}`;
    if (startDate) url += `&startDate=${encodeURIComponent(startDate)}`;
    if (endDate) url += `&endDate=${encodeURIComponent(endDate)}`;
    if (paymentStatus) url += `&paymentStatus=${encodeURIComponent(paymentStatus)}`;

    const response = await axios.get(url, headers());
    return response.data;
  },

  getOrderById: async (id: string) => {
    const response = await axios.get(`${API_URL}/api/admin/instant-orders/${id}`, headers());
    return response.data;
  },

  updateStatus: async (id: string, status: string, note?: string) => {
    const response = await axios.patch(
      `${API_URL}/api/admin/instant-orders/${id}/status`,
      { status, note },
      headers()
    );
    return response.data;
  },

  assignRider: async (id: string, riderId: string) => {
    const response = await axios.patch(
      `${API_URL}/api/admin/instant-orders/${id}/rider`,
      { riderId },
      headers()
    );
    return response.data;
  },



  downloadLabel: async (id: string) => {
    const response = await axios.get(
      `${API_URL}/api/admin/instant-orders/${id}/label`,
      {
        ...headers(),
        responseType: "blob",
      }
    );
    return response.data;
  },

  toggleKitchenStatus: async (isOpen: boolean, kitchenId?: string) => {
    const response = await axios.patch(
      `${API_URL}/api/admin/instant-orders/kitchen/toggle`,
      { isOpen, kitchenId },
      headers()
    );
    return response.data;
  },
};

export default instantOrdersApi;
